import type { Reporter } from '@thesavingsgroup/reporting/types/Reporter';
import type { RedirectConfiguration } from './types/RedirectConfiguration';
// we are including the fallback json file to handle cases where the fetch fails
// this will allow us to continue to use the application without the remote configuration
import fallbackJSON from '@thesavingsgroup/static/redirect.json';

type GetRedirectConfigurationDepdendencies = {
  baseURL: string;
  fetcher?: typeof fetch;
  reporter: Reporter;
};

export const getRedirectConfiguration =
  ({
    baseURL,
    fetcher = fetch,
    reporter,
  }: GetRedirectConfigurationDepdendencies) =>
  (): Promise<RedirectConfiguration> =>
    fetcher(`${baseURL}/redirect.json`)
      .then((response) => (response.ok ? response.json() : fallbackJSON))
      .catch((error) => {
        reporter.warn(`[REMOTE_CONFIGURATION_ERROR] ${error.message}`, {
          originalException: error,
        });
        return fallbackJSON;
      });
